/**
 * 大厅本地图标：设计系统（`icons/index.tsx`）里暂时没有的那两个。
 *
 * 为什么不直接往设计系统里加：那个文件由另一路并行开发在改，两边同时写同一个文件
 * 只会制造合并冲突；这两个图标也只有大厅这一处用得上。
 * 规格**完全照抄** `icons/index.tsx`：24 网格、几何画在 2..22、stroke=currentColor、
 * 1.5px 描边、round 端点，默认 `aria-hidden`（图标恒与文字同现）。
 *
 * ★ 硬性规则：禁止用 emoji 当图标 —— 字形随系统变、基线对不齐、深色底自带白边，
 *   而且不跟随 currentColor。
 */
import type { ReactNode, SVGProps } from 'react'

export interface LobbyIconProps extends Omit<SVGProps<SVGSVGElement>, 'children' | 'viewBox'> {
  readonly size?: number
  readonly strokeWidth?: number
  /** 传了就切成 role="img" 并挂 <title>；不传则 aria-hidden */
  readonly title?: string
}

function Svg({
  size = 20,
  strokeWidth = 1.5,
  title,
  children,
  ...rest
}: LobbyIconProps & { children: ReactNode }): ReactNode {
  const labelled = title !== undefined && title !== ''
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth={strokeWidth}
      strokeLinecap="round"
      strokeLinejoin="round"
      focusable="false"
      {...(labelled ? { role: 'img' } : { 'aria-hidden': true })}
      {...rest}
    >
      {labelled && <title>{title}</title>}
      {children}
    </svg>
  )
}

/** 返回上一屏（左向折角）。文字「返回」永远同现，所以默认无障碍静默。 */
export function IconBack(props: LobbyIconProps): ReactNode {
  return (
    <Svg {...props}>
      <path d="M14.25 5.5 7.75 12l6.5 6.5" />
    </Svg>
  )
}

/** 提醒（不是错误）。微信提示条、表单校验都用它 */
export function IconAlert(props: LobbyIconProps): ReactNode {
  return (
    <Svg {...props}>
      <path d="M12 3.75 2.75 19.5h18.5L12 3.75Z" />
      <path d="M12 9.75v4" />
      <path d="M12 16.75h.01" />
    </Svg>
  )
}
